<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import BankingTaxCodesWorkspace from '@/views/Banking/TaxCodes/BankingTaxCodesWorkspace.vue'

setPageTitle(PageMeta.Banking.TaxCodes.Title)
definePage({ meta: PageMeta.Banking.TaxCodes.Meta })
</script>

<template>
  <BankingTaxCodesWorkspace />
</template>
